import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.mahalle.app/";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Accept-Language": "tr",
  },
});
